import React, { useState, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import "./SinglePost2.scss";
// import AdvModule from "../../components/AdvModule/AdvModule";
// import ArticalBox from "../../components/ArticalBox/ArticalBox";
import BodyText from "../../components/BodyText/BodyText";
// import SocialButtons from "../../UI/SocialButtons/SocialButtons";
// import HeadHelmet from "../../UI/HeadHelmet/HeadHelmet";
import TimeFormat from "../../components/TimeFormat/TimeFormat";
import AdManagerSlot from "../../components/AdvModule/AdManagerSlot";
import { useGlobalLocation } from "../../shared/LocationContext";
import { useIdContext } from "../../shared/IdProvider";
import { urlTitle2 } from "../../shared/utility";
import CrossingData from "../../components/CrossingData/CrossingData";
import MultiplexAd from "../../components/AdvModule/MultiplexAd";
import data from "../../all__news.json"

export default function SinglePost2(props) {
  const { id, slug } = useIdContext();
  const { pathPart, location } = useGlobalLocation();
  const [isNews, setIsNews] = useState(() => setArticleState());
  // console.log("pathPart", pathPart);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  function setArticleState() {
    return data.find((post) => {
      return urlTitle2(post.title) === pathPart[1] || urlTitle2(post.title) === pathPart[2];
    });
  }
  return (
    <div className="singlePost2">
      <div className="banner-wrapper bilbord">
        <AdManagerSlot adUnitPath={location.pathname} slotNumber={"div-gpt-ad-1723658374440-0"} />
      </div>
      <div className="content">
        <main className="mainContent">
          <article className="mainContent-wrapper">
            <div className="time">
              Datum: <TimeFormat timePost={isNews.modified || isNews.time2} />
              {/* , Izvor:{" "}
              {newsPost.source} */}
            </div>
            <h1 className="mainContent-title">{isNews.title_2 || isNews.title}</h1>
            <strong className="mainContent-lead">{isNews.lead}</strong>
            <div className="mainContent-img">
              <img src={`${isNews.pics[0]}`} alt="" />
              <div className="mainContent-img_source">Foto: {isNews.pics[1]}</div>
            </div>
            <div>
              <BodyText bodyText={isNews.body} />
            </div>
            <div>{pathPart[1] === "slave" && <CrossingData />}</div>
            <div className="tags">
              <span className="tags-title">Tagovi</span>
              <div className="tags__arr">
                {isNews.tags.map((x, index) => {
                  return <span key={index}>{x}</span>;
                })}
              </div>
            </div>
          </article>
          {/* <SocialButtons location={location} /> */}
        </main>
        <aside className="newsAside">
          <div className="banner-wrapper xl_sticky">
            <AdManagerSlot adUnitPath={location.pathname} slotNumber={"div-gpt-ad-1723682121612-0"} />
          </div>
          {/* <AdvModule classes={"adClass xl_sticky"} size={"xl"} /> */}
        </aside>
      </div>
      <MultiplexAd />
    </div>
  );
}
